module.exports = __webpack_public_path__ + "img/MES_Background.221168b4.png";